import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CategoryService } from 'src/app/_services/category.service';
import { DocumentService } from 'src/app/_services/document.services';
import { UserService } from 'src/app/_services/user.service';
import { DatePipe } from '@angular/common';
import { Category } from 'src/app/_models';
import { first } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MigrationService } from 'src/app/_services/document-migration.services';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { VirtualFolderNode } from 'src/app/_models/virtualFolder';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { AlertService } from 'src/app/_services/alert.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { DialogIndexMigrateComponent } from './dialog-index-migrate/dialog-index-migrate.component';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Stack } from 'src/app/_helpers/custom-stack';
import { PopUpComponent } from 'src/app/common/pop-up/pop-up.component';
import { MatSelectChange } from '@angular/material/select';
import { COMMENT_APPENDER, COMMENT_APPLICABLE_METADATA_KEYS, MAX_CHARS, PORTAL_USER_INFO_KEY } from 'src/app/constants/portal-user-info';
import { MARK_FOR_DELETE_KEY, REASON_FOR_DELETE_KEY, REASON_FOR_DELETE_PROMPT } from 'src/app/constants/mark-for-delete';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

interface FolderFlatNode {
  expandable: boolean;
  id: number;
  folder_name: string;
  parent_id: number;
  level: number;
  isExpanded: boolean;
}

interface ApplicableMetadataComments {
  metadataName: string;
  comment: string
}

@Component({
  selector: 'app-index-documents',
  templateUrl: './index-document.component.html',
  styleUrls: ['./index-document.component.scss'],
  providers: [DatePipe]
})
export class IndexDocumentComponent implements OnInit {
  documents: any;
  categoryID: any;
  searchCtrl: string = "";
  displayedColumns: string[] = ['Folders', 'Documents'];
  indexDocList: MatTableDataSource<any>;
  categories: Category[];
  indexedError: boolean = false;
  properties: any;
  indexedDocument = []
  category: any;
  selectedDocTable: any;
  isCategorySelected: boolean = false;
  categoryMetaData: any;
  headers = ["Document Title"]
  pagesForm: FormGroup;
  pagesArray = [];
  tempPagesArray = [];
  offset: number = 0;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;  
  totalDocumentCount: number = 0;
  tableData: any
  values: any[];
  selection = new SelectionModel<any>(true, []);
  propertyKeys: String[] = [];
  isFileView: boolean = false
  selectedDocumentId: any;
  selectedValue: any;
  display: Boolean = false;
  folders = [];
  selectedFolderName: any;
  selectedFolderId: any;
  selectedUser: string
  user: any;  
  userGroups: any[]
  multiparts: any[]
  isDjango: boolean
  stagingBucket: string;
  duplicateList = [];
  isUploadedSuccess = false;
  dupDocLength = 0;
  isDuplicateAvailable = false;
  isFileLimitExceed = false;
  fileLimit = 0;  
  noFolders:boolean = false;
  navBarFolders: any[];
  allVirtualFolders;
  documentCols: String[] = [];
  noDocuments: any;
  selectedRow: Array<JSON> = [];
  folderSelected: boolean = false;
  isValidData = true;
  isValidCallInProgress = false;
  teams: any;
  selectedTeamId: any;
  selectedTab: string = 'Folder';
  setFolderActive: boolean = true;
  myFilesCount:number = 0;
  paginationPagesArray = [];  
  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;
  visibleFields = ["Document Type", "Key Date", "Subject", "Water Right ID","Document Title", "Key Year", "Ownership"];
  comment: string = "";
  portalUserInfo: any = {};
  portalUserInfoByDocumentId: any[] = [];
  reasonForDeleteByDocumentId: any[] = [];
  latestComments: ApplicableMetadataComments[] = [];


  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private documentService: DocumentService,
    private virtualFolderService: FileInboxVirtualFolderService,
    private migrationService: MigrationService,
    private alertService: AlertService,
    private httpClient: HttpClient
  ) {

    this.pagesForm = this.fb.group({
      arr: this.fb.array([])
    })
  }

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.indexDocList && this.sort) {
      this.indexDocList.sort = this.sort;
    }
  }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  private _transformer = (node: VirtualFolderNode, level: number) => {
    return {
      expandable: !!node.sub_folders && node.sub_folders.length > 0,
      id: node.id,
      folder_name: node.folder_name,
      level: level,
      parent_id: node.parent_id,
      isExpanded: true
    };
  };
  treeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualFolders = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  hasChild = (_: number, node: FolderFlatNode) => node.expandable;

  duplicateSubList: any;

  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;  
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.indexDocList.paginator = this.paginator;
    }
  }

  ngOnInit() {
    let cacheFolderId = Number(localStorage.getItem('fileInboxFolderId'));
    if (cacheFolderId && cacheFolderId > 0) {
      this.selectedFolderId = cacheFolderId;
    }
    this.getVirtualFoldersTree();
    this.getTeamsTree();
    this.getMyFilesCount();
  }

  private getTeamsTree() {
    this.migrationService
      .getTeamsAll()
      .pipe(first())
      .subscribe((teams) => {
        for (let index in teams) {
          teams[index]['active'] = false;
          teams[index]['count'] = 0;
          this.getTeamCount(teams[index]);
        }
        this.teams = teams;
      });
  }

  private getMyFilesCount() {
    this.virtualFolderService
      .getVirtualFolderCount('index', this.offset)
      .pipe(first())
      .subscribe((count) => {
        this.myFilesCount = count;
      });
  }

  async getTeamCount(team) {
    await this.virtualFolderService
      .getTeamIndexDocuments(team['id'], 0, this.offset)
      .pipe(first())
      .subscribe((resp) => {
        if (
          resp ==
          'No documents found'
        ) {
          team['count'] = 0;
        } else {
          team['count'] = resp.count;
        }
      });
  }

  
  setPagesArray(isNextButton) {
    if (isNextButton) {
      this.documents.results.forEach((element, index) => {
        var object = {}
        object['name'] = element.file_name;
        object['document_id'] = element.document_id;
        object['create_date'] = element.create_date;
        object['created_by'] = element.created_by;
        object['modifiedDate'] = element.modified_date;
        object['modified_by'] = element.modified_by;
        object['properties'] = element['meta_data']['properties'];
        object['system'] = element['meta_data']['system'];
        if (!('Ownership' in object['properties'])) { // default value as Records
          object['properties']['Ownership'] =  'Records';
        }      
        this.pagesArray.push(Object.assign(object))
  
      });
    } else {
      this.pagesArray = [];
      this.paginationPagesArray = [];
      this.tempPagesArray = [];
      this.pageIndex = 0;
      this.pageSize = 50;
      this.currentStartPageIndex = 1;
      this.currentPageSize = 50;
      this.documents.results.forEach((element, index) => {
        var object = {}
        object['name'] = element.file_name;
        object['document_id'] = element.document_id;
        object['create_date'] = element.create_date;
        object['modifiedDate'] = element.modified_date;
        object['modified_by'] = element.modified_by;
        object['created_by'] = element.created_by;
        object['properties'] = element['meta_data']['properties'];
        object['system'] = element['meta_data']['system'];
        if (!('Ownership' in object['properties'])) { // default value as Records
          object['properties']['Ownership'] =  'Records';
        }      
        this.pagesArray.push(Object.assign(object))
  
      });
    }
  }

  stringContainsAny(str: string, substrings: string[]): boolean {
    let strArray = str.split(".");
    let extension = '';
    if (strArray.length > 1) {
      extension = '.'+strArray[strArray.length - 1];
    }
    return substrings.some(substring => extension.includes(substring));
  }
  
  private getVirtualFoldersTree() {
    this.virtualFolderService
      .getTree()
      .pipe(first())
      .subscribe((folders) => {
        if(folders.length == 0){
          this.noFolders = true          
        } else {
          if (this.selectedFolderId > 0) {
            let selectedFolderList = folders.filter((folder) => folder.id === this.selectedFolderId);
            if (selectedFolderList.length > 0) {
              this.selectedFolderName = selectedFolderList[0]['folder_name'];
            }
          } else {
            this.selectedFolderName = folders[0]['folder_name'];
            this.selectedFolderId = folders[0]['id'];          
          }
          this.noFolders = false
          this.virtualFolders.data = folders;
          this.folders = folders;          
          this.navBarFolders = folders;
          this.navBarFolders.sort = this.sort; 
          this.getFlattenedVirtualFolders();          
        }
      });
  }

  docPanelExpanded(node) {
    node.isExpanded = !node.isExpanded;
  }

  async getFlattenedVirtualFolders(){    
    this.allVirtualFolders= await this.virtualFolderService.getFlattenedTree();
    const folderStack = new Stack<number>();
    let isRootNode = false;      
    let id = this.selectedFolderId;
    if (this.allVirtualFolders && this.allVirtualFolders.length > 0) {
      while(!isRootNode) {
        let selectedFolder = this.allVirtualFolders.filter(folder => folder.id == id);
        if (selectedFolder && selectedFolder.length > 0) {            
          if (selectedFolder[0].parent_id == 0) {
            isRootNode = true;
          } else {
            folderStack.push(selectedFolder[0].parent_id);
            id = selectedFolder[0].parent_id;
          }
        } else {
          isRootNode = true;
        }
      }
      while(!folderStack.isEmpty()) {
        let id = folderStack.pop();
        let treeList = this.virtualFolders._expandedData.value.filter((node) => node.id == id);
        if (treeList.length > 0) {
            this.treeControl.expand(treeList[0]);                    
        }
      }
    }
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);   
  }

  async getFlattenedVirtualTeamFolders(teamId){    
    this.allVirtualFolders= await this.virtualFolderService.getFlattenedFolderTree(teamId);
    this.selectTeam(this.selectedFolderName, this.selectedFolderId);   
  }

  onFolderSelect() {
    this.selectedTab = 'Folder';
    this.setFolderActive = !this.setFolderActive;
    for (let index in this.teams) {
      this.teams[index]['active'] = false;
    }
    if (this.setFolderActive) {
      this.getVirtualFoldersTree();
    }
  }
  
  onTeamSelect(team) {
    this.selectedTab = 'Team';
    let teamId = team.id;
    this.selectedTeamId = teamId;
    team.active = !team.active;
    for (let index in this.teams) {
      if (this.teams[index].id != team.id) {
        this.teams[index]['active'] = false;
      }
    }
    this.setFolderActive = false;
    if (team.active) {
      this.virtualFolderService
        .getFolderTree(teamId)
        .pipe(first())
        .subscribe((folders) => {
          if(folders.length == 0){
            this.noFolders = true          
          } else {
            this.selectedFolderName = folders[0]['folder_name'];
            this.selectedFolderId = folders[0]['id'];          
            this.noFolders = false
            this.virtualFolders.data = folders;
            this.folders = folders;          
            this.navBarFolders = folders;
            this.navBarFolders.sort = this.sort; 
            this.getFlattenedVirtualTeamFolders(teamId);         
          }
        });
    }
  }

  selectTeam(name, id) {  
    this.selection.clear();
    this.noDocuments = true;
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.virtualFolderService.getTeamIndexDocuments(this.selectedTeamId, id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents ==
        'No documents found'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;       
        this.category = this.documents.properties; 
        var additionalColsStr= localStorage.getItem('additionalColumns');    
        if (additionalColsStr) {
          var additionalColsList = JSON.parse(additionalColsStr);
          if (additionalColsList && additionalColsList.length > 0) {
            additionalColsList.forEach(colName => {
              let selectedItem = this.category.filter(selectedForm => selectedForm["name"] === colName);
              if (selectedItem.length > 0) {
                selectedItem[0]["visible"] = true;
              }
            });
          }
        }
        // Sort documents by file_name to match File Inbox display order (ascending A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.file_name || '').toLowerCase();
          const nameB = (b.file_name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.indexDocList = new MatTableDataSource(this.documents.results);
        this.indexDocList.sort = this.sort;
        this.indexDocList.paginator = this.paginator;
        this.setPagesArray(false);
        this.fetchMetaDataProperties();
      }
    });
  }

  selectTeamPagination(name, id) {  
    this.selection.clear();    
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.virtualFolderService.getTeamIndexDocuments(this.selectedTeamId, id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents ==
        'No documents found'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        // this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount += documents.results.length;       
        this.category = this.documents.properties; 
        documents.results.forEach(element => {
          this.documents.results.push(element);
        });
        // Sort documents by file_name to match File Inbox display order
        this.documents.results.sort((a, b) => {
          const nameA = (a.file_name || '').toLowerCase();
          const nameB = (b.file_name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.indexDocList = new MatTableDataSource(this.documents.results);
        this.indexDocList.sort = this.sort;
        this.indexDocList.paginator = this.paginator;
        this.setPagesArray(true);
        this.fetchMetaDataProperties();
      }
    });
  }

  

  setFormArray() {
    let arr = this.pagesForm.controls.arr;
    this.pagesArray.forEach(x => {
      (arr as FormArray).push(this.fb.group({
        name: x.name
      }))
    })
  }

  checkboxLabel(row?: any): string {
    //this.docIdArray = true
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
    ${row.position + 1}`;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.indexDocList.data.length;
    return numSelected === numRows;
  }

  public onCheckAllChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectAll();
    } else {
      this.deselectAll();
    }
  }

  private selectAll(): void {
    this.selection.select(...this.tempPagesArray);
  }

  private deselectAll(): void {
    this.selection.clear();
  }

  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;    
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.documentCount && currentPageSize < this.totalDocumentCount) {     
      if (this.selectedTab === "Folder") {
        this.selectFolderPagination(this.selectedFolderName, this.selectedFolderId);
      } else {
        this.selectTeamPagination(this.selectedFolderName, this.selectedFolderId);
      }
    }
    this.currentPageSize = currentPageSize;
    this.paginationPagesArray = [];
    for (let i = this.currentStartPageIndex - 1; i < currentPageSize; i++) {
      if (this.pagesArray[i]) {
        this.paginationPagesArray.push(this.pagesArray[i]);
      }
    }
    this.tempPagesArray = this.paginationPagesArray;
  }

  fetchMetaDataProperties() {
    // this.setPagesArray()
    this.categoryID = 0;
    this.isCategorySelected = true;    
    this.categoryMetaData = new MatTableDataSource(this.category);
    let additionalColumns = this.category.filter(col => col.visible && !this.visibleFields.includes(col.name))
    .map(col => col.name);
    localStorage.setItem('additionalColumns', JSON.stringify(additionalColumns));
    
    this.pagesArray.forEach(element => {
      const propertiesClone = [];
      for (var i = 0; i < this.category.length; i++) {
        this.category.forEach(element => {
          element['value'] = ""
          if (element.data_type == "options") {
            element['filteredList'] = element.values.slice().sort();
            // element['filteredList'] = this.values.slice();
          }
        });
        let properties = element.properties;
        if (properties[this.category[i].name]) {
          this.category[i].value = properties[this.category[i].name];
          if (this.category[i].name == 'Water Right ID' && this.category[i].value) {
            this.category[i].value =  this.category[i].value.toString().replace("[","").replace("]","").replace(/"/g, "");
          }
          if (this.category[i].data_type == 'date' && this.category[i].value != "" && this.category[i].value != undefined) {
            const d = new Date(this.category[i].value);
            const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
            let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
            this.category[i].value = dateString;

            // let dateStrFormat = this.category[i].value.split("/");
            // this.category[i].value = dateStrFormat[2] + "-" + dateStrFormat[0] + "-" + dateStrFormat[1];
            // this.category[i].value = new Date(Date.parse(this.category[i].value));
          }
        } else if (properties[this.category[i].name] == '') {
          this.category[i].value = properties[this.category[i].name];
        }
        this.category[i]["error"] = {"flag": false, "message": ""};
        propertiesClone.push(Object.assign({}, this.category[i]));        
        // if (this.category[i]['visible'] == true) {
        // }      
      }      
      element.objValues = propertiesClone;
    })
    this.values = Object.assign(this.category)
    this.category.forEach((element, index) => {
      if (element.data_type == "date") {
        if (this.values[element.name] == '' || this.values[element.name] == null) {

        } else {
          var dateArray = this.values[element.name].split("/")
          var date = dateArray[2] + "-" + dateArray[0] + "-" + dateArray[1]
          this.values[element.name] = date
        }
      }      
    });
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
    })
    this.paginationPagesArray = [];
    this.tableData = new MatTableDataSource(this.pagesArray);
    for (let i = this.currentStartPageIndex - 1; i < this.currentPageSize; i++) {
      if (this.pagesArray[i]) {
        this.paginationPagesArray.push(this.pagesArray[i]);
      }
    }
    this.tempPagesArray = this.paginationPagesArray;
    this.setFormArray();
  }

  selectFolder(name, id) {    
    this.selection.clear();
    this.noDocuments = true;
    this.selectedFolderName = name;
    this.selectedFolderId = id;

    this.virtualFolderService.getIndexDocuments(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents ==
        'No documents found'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;       
        this.category = this.documents.properties;
        var additionalColsStr= localStorage.getItem('additionalColumns');    
        if (additionalColsStr) {
          var additionalColsList = JSON.parse(additionalColsStr);
          if (additionalColsList && additionalColsList.length > 0) {
            additionalColsList.forEach(colName => {
              let selectedItem = this.category.filter(selectedForm => selectedForm["name"] === colName);
              if (selectedItem.length > 0) {
                selectedItem[0]["visible"] = true;
              }
            });
          }
        }
        // Sort documents by file_name to match File Inbox display order (ascending A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.file_name || '').toLowerCase();
          const nameB = (b.file_name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.indexDocList = new MatTableDataSource(this.documents.results);
        this.indexDocList.sort = this.sort;
        this.indexDocList.paginator = this.paginator;
        this.setPagesArray(false);
        this.fetchMetaDataProperties();
      }
      localStorage.setItem('fileInboxFolderId', this.selectedFolderId);
      
    });
  }

  selectFolderPagination(name, id) { 
    this.selection.clear();        
    this.selectedFolderName = name;
    this.selectedFolderId = id;

    this.virtualFolderService.getIndexDocuments(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents ==
        'No documents found'
      ) {
        //this.noDocuments = true;
        //this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        // this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount += documents.results.length;       
        this.category = this.documents.properties;
        documents.results.forEach(element => {
          this.documents.results.push(element);
        });
        // Sort documents by file_name to match File Inbox display order (ascending A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.file_name || '').toLowerCase();
          const nameB = (b.file_name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.indexDocList = new MatTableDataSource(this.documents.results);
        this.indexDocList.sort = this.sort;
        this.indexDocList.paginator = this.paginator;
        this.setPagesArray(true);
        this.fetchMetaDataProperties();
      }
    });
  }



  trackByIndex(index, item) {
    return item.id;
  }

  checkBoxChecked(column, tabName) {
    var actualColumnName = column + tabName;
    var checkboxvalue = <HTMLInputElement>document.getElementById(actualColumnName);
    var isChecked = checkboxvalue.checked;
    if (isChecked) {
      if (this.selection.selected.length == 0) {
        this.alertService.error("Please select a row to copy data to other selected column");
              setTimeout(() => {    
                this.alertService.clear();          
              }, 5000);
        return;
      }
      if (this.selection.selected.length > 1) {
        this.alertService.error("Please select a single row to copy data from the selected row to the selected column");
              setTimeout(() => {
                this.alertService.clear();         
              }, 5000);
        return;
      }      
      let selectedList = this.selection.selected;
      let updateList = selectedList.filter(row => this.tempPagesArray.map(value => value.document_id).includes(row.document_id));
      var selectedRow = null;
      if (updateList.length > 0) {
        selectedRow = updateList[0];
      } else {
        return;
      }
      var tempValue
      selectedRow['objValues'].forEach(element => {
        if (element.name == column && !element["error"]["flag"]) {
          tempValue = element.value
        }
      });
      if (tempValue || tempValue == false) {
        this.tempPagesArray.forEach(element => {
          element['objValues'].forEach(property => {
            if (property.name == column) {
              if (property.data_type == "Date") {
                      var dateArray = tempValue.value.split("-");
                      var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
                      property.value = date;
              } else if (column == "Water Right ID") {  
                if (!property.value) {
                  property.value = tempValue;
                } else if (property.value) {
                  let wrList = tempValue.split(",");
                  if (wrList.length > 1) {
                    wrList.forEach(wr => {
                      if (!property.value.includes(wr)) { 
                        property.value += "," + wr;
                      }
                    });
                  } else {
                    if (!property.value.includes(tempValue)) { 
                      property.value += "," + tempValue;
                    }
                  }      
                }
              } else {
                property.value = tempValue;
              }
            }
          });
        });
      }
    }
    else {
      this.tempPagesArray.forEach(element => {
        element['objValues'].forEach(property => {
          if (property.name == column) {            
            property.value = null
          }
        });
      });
    }
  }

  updateList(documentId: string, documentIndex: number, propertyIndex: number, property: any, event: any) {
    var editField;
    if (event instanceof MatSelectChange)
      editField = event.value;
    else if (event instanceof MatSlideToggleChange)
      editField = event.checked
    else
      editField = event.target.value;
    this.pagesArray[documentIndex].objValues[propertyIndex].value = editField;
    var name = property.name;
    if (COMMENT_APPLICABLE_METADATA_KEYS.includes(name)) {
      this.openDialog(name, documentId, this.tempPagesArray[documentIndex])
    } else if (MARK_FOR_DELETE_KEY === name) {
      if (editField)
        this.openDeleteDialog(this.pagesArray[documentIndex])
    }

    if (name == 'Water Right ID') {
      let wrIds = [];
        if (editField) {
          let wrList = editField.split(",");
          for (var index in wrList) {
            wrIds.push(wrList[index].trim());
          }
        }
        var request = {
          "value": wrIds,
          "key": 'WR_ID'
        }
        this.isValidCallInProgress = true;
        this.documentService.validateMetadata(request).subscribe(resp => {            
          if (resp && JSON.stringify(resp) !== "{}") {            
            for (var i in wrIds) {
              if (resp[wrIds[i]]) {
                this.isValidData = true;
              } else {
                this.isValidData = false;                
              }
            }
            if (!this.isValidData) {
              property["error"] = {
                "flag": true,
                "message": "Please enter a valid " + name
              }
            } else {
              property["error"] = {
                "flag": false,
                "message": ""
              }
            }
          } else {
            property["error"] = {
              "flag": false,
              "message": ""
            }
          }
          this.isValidCallInProgress = false;
        }, error => {
          console.log(error);
          this.isValidCallInProgress = false;
        });
    }
    if (name == 'Placeholder UUID') {
      let placeholderUUID = [];
        if (editField) {
          let wrList = editField.split(",");
          for (var index in wrList) {
            placeholderUUID.push(wrList[index].trim());
          }
        }
        var request = {
          "value": placeholderUUID,
          "key": 'P_UUID'
        }
        this.isValidCallInProgress = true;
        this.documentService.validateMetadata(request).subscribe(resp => {            
          if (resp && JSON.stringify(resp) !== "{}") {            
            for (var i in placeholderUUID) {
              if (resp[placeholderUUID[i]]) {
                this.isValidData = true;
              } else {
                this.isValidData = false;                
              }
            }
            if (!this.isValidData) {
              property["error"] = {
                "flag": true,
                "message": "Please enter a valid " + name
              }
            } else {
              property["error"] = {
                "flag": false,
                "message": ""
              }
            }
          } else {
            property["error"] = {
              "flag": false,
              "message": ""
            }
          }
          this.isValidCallInProgress = false;
        }, error => {
          console.log(error);
          this.isValidCallInProgress = false;
        });
    }
    if (name == "Key Date") {
       if (editField) {
        const d = new Date(editField);
        const currentDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        var list = this.pagesArray[documentIndex].objValues.filter((obj) => obj.name == "Key Year");
        if (list && list.length > 0) {
          list[0].value = dateStrFormat[0];
        }        
        property.value = dateString;
        property["error"] = {
            "flag": false,
            "message": ""
        }      
      } else {
        property["error"] = {
            "flag": true,
            "message": "Date is invalid"
        }
      }
    }
    if (name == "Key Year") {
      if (editField) {
        if (isNaN(editField) || editField.length > 4 || editField.length < 4) {
          property["error"] = {
            "flag": true,
            "message": "Please enter a valid key year"
          }
        } else {
          property["error"] = {
            "flag": false,
            "message": ""
          }
        }
      }
    }
  }

  indexTracker(index: number, value: any) {
    return index;
  }

  checkAllSelectedRowsValid(updateList) {
    let isValidData = true;
    updateList.forEach((element, index) => {
      element['objValues'].forEach(property => {
          if (property.name == 'Water Right ID' && property["error"]["flag"]) {
            isValidData = false;
          }
          if (property.name == 'Placeholder UUID' && property["error"]["flag"]) {
            isValidData = false;
          }
          if (property.name == 'Key Year' && (property["error"]["flag"] || (property.value == undefined || property.value === ""))) {
            isValidData = false;
          }
          if (property.name == 'Subject' && (property.value == undefined || property.value === "")) {
            isValidData = false;
          }      
          if (property.name == 'Ownership' && (property.value == undefined || property.value === "")) {
            isValidData = false;
          }
          if (property.name == 'Document Type' && (property.value == undefined || property.value === "")) {
            isValidData = false;
          }
      });
    });
    return isValidData;
  }

  migrateECM() {
    if (this.selection.selected.length == 0) {
      this.alertService.error("Please select documents to update");
            setTimeout(() => {
              this.alertService.clear();              
            }, 2000);
      return;
    }
    if (this.isValidCallInProgress) {
      this.alertService.success("Metadata validation is in progress, please try again");
            setTimeout(() => {
              this.alertService.clear();         
            }, 2000);
      return;
    }
    let selectedList = this.selection.selected;
    let updateList = selectedList.filter(row => this.tempPagesArray.map(value => value.document_id).includes(row.document_id));
    let isValidData = this.checkAllSelectedRowsValid(updateList);
    if (!isValidData) {
      this.alertService.error("Please enter the valid metadata values");
    } else { 
    //   let records = [];
    //   var today = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
    //   let selectedList = this.selection.selected;
    //   let updateList = selectedList.filter(row => this.tempPagesArray.map(value => value.document_id).includes(row.document_id));
    //   updateList.forEach((element, index) => {
    //     let properties = {};
    //     element['objValues'].forEach(property => {
    //       if (property.data_type === "date") {
    //         if (property.value) {
    //           var dateArray = property.value.split("-");
    //           var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
    //           property.value = date;
    //           properties[property.name] = date;
    //         } else{
    //           properties[property.name] = property.value;
    //         }
    //       }
    //       else if (property.data_type === "int") {
    //         property.value = parseInt(property.value);
    //         properties[property.name] = parseInt(property.value);
    //       }
    //       else if (property.data_type == "bool") {
    //         properties[property.name] = property.value
    //         if (property.value !== true) {
    //           property.value = false;
    //           properties[property.name] = false;
    //         }
    //       }
    //       else if (property.name == "Document Type") {
    //         if (property.value) {
    //           let types = property.value.split(">");
    //           if (types.length == 3) {
    //             properties[property.name] = types[2].trim();            
    //           } else {
    //             properties[property.name] = property.value;
    //           }
    //         } else {
    //           properties[property.name] = property.value;
    //         }
    //       }
    //       else if (property.name == 'Water Right ID') {
    //         let wrIds = [];
    //         if (property.value) {
    //           let wrList = property.value.split(",");
    //           for (var index in wrList) {
    //             wrIds.push(wrList[index].trim());
    //           }
    //         }
    //         properties[property.name] = wrIds;
    //       }
    //       else {          
    //         properties[property.name] = property.value;
    //       }
    //     });
    //     properties["Portal User Info"] = {
    //       reviewedBy: ""
    //     };
    //     properties["Source"] = "Legacy Migration";
    //     var systemProperties = {
    //       "fileName": element.name,
    //       "lastModifiedDate": today,
    //       "size": element.system.size,
    //       "type": element.system.type
    //     }
    //     var recordIndex = {
    //       "docId": element.document_id,
    //       "title": element.name,
    //       "meta_data": properties,
    //       "system_properties": systemProperties
    //     }
    //     records.push(recordIndex);      
    //   });
    //   var request = {
    //     "recordsIndex": records        
    //   }

    //   this.documentService.indexDocumentMetadata(request)
    //     .subscribe(resp => {
    //       if (resp && resp == 'Document indexing is in process') {
    //          this.alertService.success("Documents migration initiated successfully, will take few seconds to complete");
    //         setTimeout(() => {
    //           this.refresh();
    //         }, 2000);      
    //       } else{
    //         this.alertService.error("Document migration failed");
    //       }
      
    //       } else{
    //         this.alertService.error("Document migration failed");
    //       }

    //     }
    //   )
    let dialogRef = this.dialog.open(DialogIndexMigrateComponent,
      { width: '100%', height: "80%", data: { uploadFileList: updateList} });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.alertService.success("Documents migration completed successfully");
            setTimeout(() => {
              this.refresh();
            }, 2000);
      } else {
        this.alertService.error("Document migration failed");
        setTimeout(() => {
          this.alertService.clear();
        }, 2000);
      }
    });
    }
    
  }

  fileView(doc) {    
    //console.log("doc id " + this.documentID);
    const msOfficeFiles = [".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".dotx", ".dotm",".docm", ".xlsb", ".xlam", ".pst", ".rtf"];
    
    const result = this.stringContainsAny(doc.name, msOfficeFiles);
    if (result) {
      this.documentService.viewCaptureDocument(doc.document_id)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            this.httpClient.get(url, { responseType: 'blob' })
            .subscribe(blob => {
              saveAs(blob, doc.name);
            });
          }
        );
    } else {
      this.documentService.viewCaptureDocument(doc.document_id)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            //window.open(url);
            window.open(url, '_blank', 'location=yes,height=900,width=900,scrollbars=yes,status=yes');
          }
        );
    }
  }

  refresh() {
    this.getFlattenedVirtualFolders();
    this.getTeamsTree();
    this.getMyFilesCount();
  }

  save() {
    if (this.selection.selected.length == 0) {
      this.alertService.error("Please select documents to update");
            setTimeout(() => {
              this.alertService.clear();     
            }, 2000);
      return;
    }
    if (this.isValidCallInProgress) {
      this.alertService.success("Metadata validation is in progress, please try again");
            setTimeout(() => {
              this.alertService.clear();            
            }, 2000);
      return;
    }
    let selectedList = this.selection.selected;
    let updateList = selectedList.filter(row => this.tempPagesArray.map(value => value.document_id).includes(row.document_id));
    let isValidData = this.checkAllSelectedRowsValid(updateList);
    if (!isValidData) {
      this.alertService.error("Please enter the valid metadata values");
    }  else {      
      let records = [];     
      updateList.forEach((element, index) => {
        let properties = {};
        element['objValues'].forEach(property => {
          if (property.name != 'Document Title' && property.name != 'Document ID' && property.name != 'Creation Date' && property.name != 'Created By' && property.name != 'Modified Date' && property.name != 'Modified By' && property.name != 'Size' && property.name != 'PAP Metadata' && property.name != 'Portal User Info' && property.name != 'Digitization User Info' && property.name != 'Security Groups' && property.name != 'Version' && property.name != 'Batch ID' && property.name != 'ImageTrust Document ID' && property.name != 'Document Source' && property.name != 'File Type' && property.name != 'Reference Entities') {
            if (property.data_type === "date") {
              if (property.visible) {
                if (property.value) {
                  const editField = new Date(property.value);          
                  let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                  property.value = dateString;
                  properties[property.name] = dateString;                
                } else{
                  properties[property.name] = property.value;
                }
              } else {
                if (property.value && property.value != "") {
                  const editField = new Date(property.value);          
                  let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                  property.value = dateString;
                  properties[property.name] = dateString;
                }
              }
            }
            else if (property.data_type === "int") {
              if (property.visible) {
                property.value = parseInt(property.value);
                properties[property.name] = parseInt(property.value);
              }
            }
            else if (property.data_type == "bool") {
              if (property.visible) {
                properties[property.name] = property.value
                if (property.value !== true) {
                  property.value = false;
                  properties[property.name] = false;
                }
              }
            }
            else if (property.name == 'Water Right ID') {
              let wrIds = [];
              if (property.value) {
                let wrList = property.value.split(",");
                for (var index in wrList) {
                  wrIds.push(wrList[index].trim());
                }
              }
              properties[property.name] = JSON.stringify(wrIds);
            }
            else {
              if (property.value && property.value != "") {
                properties[property.name] = property.value;
              }        
            }
        } else if (property.name == PORTAL_USER_INFO_KEY) {
            if (this.portalUserInfoByDocumentId.length > 0) {
              const portalUserInfo = this.portalUserInfoByDocumentId.find(obj => Object.keys(obj).includes(element.document_id));
              if (portalUserInfo && Object.keys(portalUserInfo).length > 0) {
                const [innerData] = Object.values(portalUserInfo)
                properties[property.name] = innerData
              }
            }
        } else if (property.name == REASON_FOR_DELETE_KEY) {
            let markForDelete = element['objValues'].find(key => key.name === MARK_FOR_DELETE_KEY);
            if (this.reasonForDeleteByDocumentId.length > 0 && markForDelete.value) {
              const reasonForDelete = this.reasonForDeleteByDocumentId.find(obj => Object.keys(obj).includes(element.document_id));
              if (reasonForDelete && Object.keys(reasonForDelete).length > 0) {
                console.log(reasonForDelete[element.document_id])
                properties[property.name] = reasonForDelete[element.document_id]
              }
            }
          }
        });
        var recordIndex = {
          "docId": element.document_id,
          "properties": properties
        }
        records.push(recordIndex);
      });
      var request = {
        "recordsIndex": records        
      }
      this.documentService.saveInterimMetadata(request)
        .subscribe(resp => {
          if (resp && resp == 'All records updated') {
            this.alertService.success("Documents updated successfully");
            setTimeout(() => {
              this.refresh();
            }, 2000);      
          } else{
            this.alertService.error("Document updation failed");
            setTimeout(() => {
              this.alertService.clear();            
            }, 2000);
          }
        }
      );
      this.resetComments();
    }
  }

  openDialog(fieldName: any, documentId: any, document: any): void {
    let index: number;
    let update: boolean = false;
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: 'Please enter a comment for this change (no more than ' + MAX_CHARS + ' characters:' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.comment = result.comment.trim();
        let key = fieldName + COMMENT_APPENDER;
        let currentPortalUserInfo = document.objValues.find(key => key.name === PORTAL_USER_INFO_KEY);
        let currentPortalUserInfoObj: any = {};
        this.portalUserInfo = {}

        // Checks if a value is currently present for 'Portal User Info'
        if (currentPortalUserInfo.value != '')
          currentPortalUserInfoObj = JSON.parse(currentPortalUserInfo.value)

        // If Portal User Info is completely empty assign it the current value
        if (this.portalUserInfo.constructor === Object && Object.keys(this.portalUserInfo).length === 0) {
          this.portalUserInfo = JSON.parse(JSON.stringify(currentPortalUserInfoObj))
        }

        // If portal user array currently has data, check to see if a comment was already made for this document
        if(this.portalUserInfoByDocumentId.length > 0) {
          index = this.portalUserInfoByDocumentId.findIndex(obj => documentId in obj);
          if (index != -1 && index !== undefined) { // If dcoument is found in the array, we need t
            const [innerData] = Object.values(this.portalUserInfoByDocumentId[index])
            this.portalUserInfo = innerData;
            update = true;
          }
        }

        if (this.comment.trim() != '') {
          if (this.portalUserInfo[key] && Object.keys(currentPortalUserInfoObj).length > 0) {
            let num = currentPortalUserInfoObj[key]?.length;
            let versions = Number.isNaN(num) || num === undefined ? 0: num;
            if (this.portalUserInfo[key].length > versions)
              this.portalUserInfo[key][versions] = {comment: this.comment, version: (versions + 1)}
            else {
              this.portalUserInfo[key].push({
                comment: this.comment,
                version: ++versions
              });
            }
          } else {
            this.portalUserInfo[key] = []
            this.portalUserInfo[key].push({
              comment: this.comment,
              version: 1
            });
          }
        }

        var documentIdObj: Record<string, any> = {
          [documentId]: this.portalUserInfo
        };

        if (update)
          this.portalUserInfoByDocumentId[index] = documentIdObj
        else
          this.portalUserInfoByDocumentId.push(documentIdObj)
        
        console.log(this.portalUserInfoByDocumentId)
      }
    });
  }

  // In case users attempt to make more changes without leaving the page
  resetComments() {
    this.portalUserInfo = {}
    this.portalUserInfoByDocumentId = []
  }

  openDeleteDialog(document: any): void {
    let index: number;
    let update: boolean = false;
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: REASON_FOR_DELETE_PROMPT }
    });

    dialogRef.afterClosed().subscribe(result => {
      const metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === REASON_FOR_DELETE_KEY)
      if (metadataComment === undefined)
        this.latestComments.push({metadataName: REASON_FOR_DELETE_KEY, comment: result.comment.trim()})
      else
        metadataComment.comment = result.comment.trim();

      let reasonForDelete = document.objValues.find(key => key.name === REASON_FOR_DELETE_KEY);
      if (reasonForDelete && Object.keys(reasonForDelete).length > 0) {
        // Sets Reason for Delete value for specific document
        reasonForDelete.value = result.comment.trim();


        // Create an object to update the tracker in case multiple mark for delete changes have occured
        var documentIdObj: Record<string, any> = {
          [document.document_id]: result.comment.trim()
        };

        if(this.reasonForDeleteByDocumentId.length > 0) {
            index = this.reasonForDeleteByDocumentId.findIndex(obj => document.document_id in obj);
          if (index != -1 && index !== undefined) {
            update = true;
          }
        }

        if (update)
          this.reasonForDeleteByDocumentId[index] = documentIdObj
        else
          this.reasonForDeleteByDocumentId.push(documentIdObj)
      }
    })
  }
}